import { Component, Input, OnInit } from '@angular/core';
import { ngxLoadingAnimationTypes } from 'ngx-loading';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
 @Input('loading') loading: boolean = false;
 public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  constructor() { }

  ngOnInit(): void {
  }

}
